import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d3b037a8&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=d3b037a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b037a8",
  null
  
)

export default component.exports